import { Component } from '@angular/core';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';

import { LocationsTableComponent } from './locations-table/locations-table.component';
import { NewLocationModalComponent } from './new-location-modal/new-location-modal.component';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';

@Component({
  selector: 'app-locations',
  imports: [
    LocationsTableComponent,
    MdbButtonComponent
  ],
  templateUrl: './locations.component.html',
  styleUrl: './locations.component.scss',
})
export class LocationsComponent {
  constructor(
    private modalService: MdbModalService,
    private notificationService: CustomNotificationService
  ) {}

  openNewLocationModal () {
    const modalRef = this.modalService.open(NewLocationModalComponent,
      {modalClass: 'modal-xl',
        ignoreBackdropClick: true
      });
    modalRef.onClose.subscribe((location) => {
      if(!location)
        return;

      this.notificationService.success('LOCATIONS.SUCCESSFULLY_CREATED');
    });
  }
}
